import { useState } from 'react';
import { MediaListProps, MediafileType } from '../types';

const DISLIKED_MAP_FOR_OPTIMIZATION: Record<string, boolean | undefined> = {};

type UseDislikeProps = {
  id: MediafileType['id'];
  streamId: MediaListProps['streamId'];
  mediafileIsDisliked: MediafileType['mediafileIsDisliked'];
};

const useDislike = ({ id, streamId, mediafileIsDisliked }: UseDislikeProps) => {
  const dislikedMapKey = `${streamId}_${id}`;
  const [isDisliked, setIsDisliked] = useState(
    DISLIKED_MAP_FOR_OPTIMIZATION[dislikedMapKey] ?? mediafileIsDisliked ?? false
  );

  const onDislike = (value: boolean) => {
    setIsDisliked(value);
    DISLIKED_MAP_FOR_OPTIMIZATION[dislikedMapKey] = value;
  };

  return {
    isDisliked,
    onDislike,
  };
};

export default useDislike;
